import { createModule } from '../createModule';

export const representative = createModule('representative');